<template>
  <div class="pos-sidebar-footer">
    <div class="subtotal">
      <div class="text">{{ $t('restaurantSale.subtotal') }}</div>
      <div class="price" data-id="price-subtotal">
        {{ defaultCrrency }}
        {{
          (tableSelected.sub_total - tableSelected.total_pre_charge_amount)
          | format_number
        }}
      </div>
    </div>
    <div class="taxes">
      <div class="text">VAT {{ vatRate ? '(' + vatRate + '%)' : '' }}</div>
      <div class="price">
        {{ defaultCrrency }}
        {{ tableSelected.vat_amount | format_number }}
      </div>
    </div>
    <div class="total">
      <div class="text">{{ $t('restaurantSale.total') }}</div>
      <div class="price" data-id="price-subtotal">
        {{ defaultCrrency }}
        {{
          (tableSelected.invoice_amount -
            tableSelected.total_pre_charge_amount)
          | format_number
        }}
      </div>
    </div>
    <div class="btn-row">
      <!-- <ts-button
        :disabled="
          !tableSelected.table_id ||
            tableSelected.invoice_status != 'Unpaid' ||
            tableSelected.guest_level_id != 2
        "
        @click.prevent="$emit('showLinkedKeysForm')"
        ><i class="fas fa-key fa-fw fa-lg"></i>
        {{ $t('restaurantSale.linkedKey') }}
      </ts-button>
      <ts-button
        :disabled="tableSelected.invoice_status != 'Unpaid'"
        @click.prevent="$emit('showCombineTableForm')"
        ><i class="fas fa-object-ungroup fa-fw fa-lg"></i>
        {{ $t('restaurantSale.combineTable') }}
      </ts-button>
      <ts-button
        :disabled="tableSelected.invoice_status != 'Unpaid'"
        @click.prevent="$emit('moveTable')"
        ><i class="fas fa-chalkboard-teacher fa-fw fa-lg"></i>
        {{ $t('restaurantSale.moveTable') }}</ts-button
      >
      <ts-button
        @click.prevent="$emit('cleanTable')"
        :disabled="
          !tableSelected.table_id || tableSelected.invoice_status == 'Unpaid'
        "
        ><i class="fas fa-object-group fa-fw fa-lg"></i>
        {{ $t('restaurantSale.cleanTable') }}</ts-button
      > -->
      <ts-button :disabled="tableSelected.invoice_status != 'Unpaid'" @click.prevent="$emit('addMoreOrder')"
        color="success"><i class="fas fa-cart-plus fa-fw fa-lg"></i>
        {{ $t('restaurantSale.add') }}</ts-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarFooter',
  props: {
    tableSelected: {
      type: Object,
      default: () => ({})
    },
    defaultCrrency: {
      type: String,
      default: ''
    },
    vatRate: {
      type: Number,
      default: 0
    },
    printing: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    format_number(value) {
      if (value) {
        return `${parseFloat(value).toLocaleString()}`
      }
      return 0
    }
  }
}
</script>
